import { Component, OnInit, AfterViewInit, OnDestroy } from '@angular/core';
import { UserService } from '../users-module/services/user.service';
import { ScreeningService } from '../screening-module/services/screening.service';
import { ToastrService } from 'ngx-toastr';
import { ScreeningLight, ObjectUpdatePayload } from '../models/screeningInvite';
import { Subject, Subscription } from 'rxjs';
import * as _ from 'lodash';
import { FilteringService } from '../services/filtering.service';
import { FilterDataType, SimpleDataFilter } from '../models/simpleDataFilter';
import { ScreeningFilter, ScreeningOrderByContract, StandAloneFilter } from '../models/ScreeningFilter';
import { PaginationEventData } from '../shared-components-module/pagination-top/models/paginationEventData';
import { PaginationService } from '../shared-components-module/pagination-top/services/pagination.service';
import { ReportTaggingService } from '../services/report-tagging.service';
import { ReportTag } from '../models/reportTag';
import { AuthService } from '../services/auth.service';
import { SearchPackageService } from '../services/search-package.service';

@Component({
    selector: 'app-processing-list',
    templateUrl: './processing-list.component.html',
    styleUrls: ['./processing-list.component.less']
})

export class ProcessingListComponent implements OnInit, AfterViewInit, OnDestroy {
    public displayFilters = true;
    public listner$: Subject<any>;
    public clientlistner$: Subject<any>;
    public sub: Subscription;
    public settingsSub: Subscription;
    public selectedPipelineStage: number;

    constructor(public users: UserService,
        public screening: ScreeningService,
        public toast: ToastrService,
        public auth: AuthService,
        public filtering: FilteringService,
        public paginate : PaginationService,
        public searchPackage: SearchPackageService) {
    }

    public ngOnInit(): void {

        this.screening.screenings = [];
        this.filtering.filters = [];
        this.screening.activeTag = null;
        this.screening.FetchScreeningsForProcessingList(0, this.paginate.pageIncrement);
    
    }

    public ngOnDestroy(): void {
      this.screening.screenings = [];
      this.filtering.filters = [];
    }

    public ngAfterViewInit(): void {
        // attach a keypress listener if the user presses enter, the filters will be applied
        document.getElementById('filterPanel').addEventListener('keypress', (e) => {
            if (e.key === 'Enter') {
                this.applyFilters();
            }
        });
    }

    public applyFilters(): void {
        this.screening.screenings = [];
        this.screening.quickFilterApplied = false;
        this.screening.activeTag = null;
        this.screening.FetchScreeningsForProcessingList(0, this.paginate.pageIncrement);
    }

    public applyStandAloneFilters() : void {
        this.screening.screenings = [];
        this.screening.quickFilterApplied = false;
        this.screening.activeTag = null;
        this.screening.FetchByStandaloneForProcessingList(0, this.paginate.pageIncrement);
    }

    public clearFilters(): void {
        this.screening.screeningFilter = new ScreeningFilter();
        this.screening.orderBy = new ScreeningOrderByContract();
        this.screening.screenings = [];
        this.filtering.filters = [];      
        this.screening.quickFilterApplied = false;
        this.screening.activeTag = null;
        this.screening.FetchScreeningsForProcessingList(0,this.paginate.pageIncrement);
    }


    public showFilters(): void {
        this.displayFilters = !this.displayFilters;
    }

    public update(val: any) {
        this.screening.screeningFilter[val.property] = val.time;
    }

    public onPaginationChanged(event: PaginationEventData) {
        this.screening.FetchScreeningsForProcessingList(event.offset,this.paginate.pageIncrement);
        console.log('SETTING OFFSET', event.offset);
    }


    public releaseTntReportResults(screening: ScreeningLight): void {
        screening.released = true;
        this.screening.releaseTntReportResults(screening.id).subscribe((resp: any) => {
            this.toast.success('Your screening has been released by the system.', 'Screening Released');
        });
    }

    public refetch()
    {
        console.warn('refetch trigger')
        this.screening.FetchScreeningsForProcessingList(0,this.paginate.pageIncrement);
    }

    
  filterByPipelineStage() {
    console.log(this.selectedPipelineStage);
    this.screening.quickFilterApplied = false;
    this.screening.activeTag = null;
    //note, hardcoding this for emp ver for now, can make it more dynamic later
    this.screening.FetchBySearchAndPipeStageForProcessingList(0, 50, this.selectedPipelineStage, 5);
  }
}
